import styled from 'styled-components'
import theme from '../../styles/theme'

const StFigure = styled.figure`
  margin: 0 auto;
  max-width: ${theme.maxWidth};
  figcaption{
    display: flex;
    font-size: calc(${theme.fonttitlesize} / 2.4 );
    font-family: ${theme.fonttitle3};
    font-style: italic;
    align-items: flex-end;
    justify-content: center;
    margin-top: calc( -${theme.fonttitlesize} / 4);
    position: relative;
    z-index: 2;
    @media(max-width: 800px){
      display: block;
    }
    strong{
      background-color: ${theme.accent};
      color: ${theme.clearcolor};
      font-family: ${theme.fonttitle};
      font-size: calc(${theme.fonttitlesize} / 2 );
      text-transform: uppercase;
      padding: calc(${theme.fonttitlesize} / 4);
      font-style: normal;
      margin: 0 1rem;
      @media(max-width: 800px){
        display: block;
        padding: calc(${theme.fonttitlesize} / 6);
        ;
      }
    }
  }
`

const CoreParagraph = styled.div`
  h2{
    border: 2px solid #0f0;
  }
`

const CoreBlock = styled.div`
  h2{
    position: relative;
    padding-top: 1.5rem;
    &:before{
      /* position: absolute; */
      content: '...';
      color: ${theme.accent};
      position: relative;
      top: -1rem;
      padding-right: 0.5rem;
      /* bottom: -10px;
      left: 0; */
    }
  }

  blockquote{
    border: 3px solid ${theme.accent};
    padding: 2rem;
    margin-left: auto;
    margin-right: auto;
    max-width: calc(${theme.normalWidth} + 4rem) ;
    p{
      font-family: ${theme.fonttitle3};
      font-size: calc(${theme.fonttitlesize} / 2 );
      line-height: calc(${theme.fonttitlesize} / 1.5 );
      font-style: italic;
      strong{
        color: ${theme.complementary};
        font-size: calc(${theme.fonttitlesize} / 1 );
      }
    }
  }
`

export { StFigure, CoreBlock, CoreParagraph}